import { canUseCalendarAdminMode } from './permissionConfig';

export const CALENDAR_EVENT_MUTATION_SCOPE = {
  OWNER: 'owner',
  ADMIN: 'admin',
};

const normalizeId = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  return String(value);
};

export const getCalendarEventOwnerId = (event) => (
  event?.extendedProps?.createdBy
  ?? event?.createdBy
  ?? event?.created_by
  ?? null
);

export const isCalendarEventOwner = (userInfo, event) => {
  const userId = normalizeId(userInfo?.user_id);
  const ownerId = normalizeId(getCalendarEventOwnerId(event));

  return userId !== null && ownerId !== null && userId === ownerId;
};

export const canEditCalendarEvent = ({ calendarMode, event, userInfo }) => {
  if (!event || event?.extendedProps?.is_restricted_period) {
    return false;
  }

  if (calendarMode === 'admin') {
    return canUseCalendarAdminMode(userInfo);
  }

  if (calendarMode !== 'normal' && calendarMode !== 'bidon') {
    return false;
  }

  return isCalendarEventOwner(userInfo, event);
};

export const shouldPassCalendarEventClickThrough = ({ calendarMode, event, userInfo }) => {
  if (
    calendarMode !== 'normal'
    || !event
    || event?.extendedProps?.is_restricted_period
  ) {
    return false;
  }

  return !isCalendarEventOwner(userInfo, event);
};

export const getCalendarEventMutationScope = (calendarMode, userInfo) => (
  calendarMode === 'admin' && canUseCalendarAdminMode(userInfo)
    ? CALENDAR_EVENT_MUTATION_SCOPE.ADMIN
    : CALENDAR_EVENT_MUTATION_SCOPE.OWNER
);

export const getCalendarEventMutationPath = (scope, eventId) => {
  const basePath = scope === CALENDAR_EVENT_MUTATION_SCOPE.ADMIN
    ? '/admin/events'
    : '/events';

  return `${basePath}/${eventId}`;
};
